import type { Component } from 'vue';

export enum IItemType {
  none = 'none',
  submenu = 'submenu',
  menuitem = 'menuitem'
}

interface IBase {
  name: string;
  hidden?: boolean;
}

export interface IMenuItem extends IBase {
  type: IItemType.menuitem | IItemType.none;
  name: string;
  path: string;
  redirect?: string;
  label?: string;
  component: Component | Function;
  icon?: string;
  meta?: Record<string, any>;
  props?: boolean;
  en?: string;
}

export interface ISubMenu extends IBase {
  type: IItemType.submenu;
  icon?: string;
  name: string;
  label?: string;
  children: IMenuItem[];
  // 扩展点: 未来 submenu 承载路由，不过要注意 children 与 routes 中有命名冲突
  // path?: string;
  // component?: Component | AsyncComponent;
}
export type IMenu = ISubMenu | IMenuItem
const fullRoutes: IMenu[] = [
  {
    name: "property",
    type: IItemType.submenu,
    label: '资产',
    icon: 'archive',
    children: [
      {
        path: "/account",
        name: "account",
        type: IItemType.menuitem,
        label: '账号资产', // 发信账号
        icon: 'Coin',
        component: () => import("@/pages/account/index.vue"),
        props: true,
      },
      {
        path: "/material/list",
        name: "material-list",
        type: IItemType.menuitem,
        label: '素材资产', // 素材库
        icon: 'Aim',
        component: () => import("@/pages/material/index.vue"),
      },
      {
        path: "/target",
        name: "target",
        type: IItemType.menuitem,
        label: '截流线索', // 收信账号
        icon: 'Notebook',
        component: () => import("@/pages/target/index.vue"),
        props: true,
      },
      {
        path: "/up",
        name: "up-owner",
        type: IItemType.menuitem,
        label: '博主资产', // 收信账号
        icon: 'Notebook',
        component: () => import("@/pages/up/index.vue"),
        props: true,
      },
    ]
  },
  {
    name: "task",
    type: IItemType.submenu,
    label: '任务',
    icon: 'git-pull-request',
    children: [
      {
        path: "/missions",
        name: "missions",
        type: IItemType.menuitem,
        label: '运营任务',
        icon: 'Collection',
        component: () => import("@/pages/missions/index.vue"),
        props: true,
      },
      {
        path: "/material/mission",
        name: "material-mission",
        type: IItemType.menuitem,
        label: '采集任务',
        icon: 'Aim',
        component: () => import("@/pages/material/mission.vue"),
      },
      {
        path: "/pull",
        name: "pull",
        type: IItemType.menuitem,
        label: '截流任务',
        icon: 'Aim',
        component: () => import("@/pages/pull/index.vue"),
      }
    ]
  },
  {
    name: "collection",
    type: IItemType.submenu,
    label: '集合',
    icon: 'package',
    children: [
      {
        path: "/post-plan",
        name: "post-plan",
        type: IItemType.menuitem,
        label: '视频集合',
        icon: 'Management',
        component: () => import("@/pages/post-plan/index.vue"),
        props: true,
      },
      {
        path: "/content-link-plan",
        name: "content-link-plan",
        type: IItemType.menuitem,
        label: '链接集合',
        icon: 'Management',
        component: () => import("@/pages/content-link-plan/index.vue"),
        props: true,
      },
    ]
  },
  {
    name: "analysis",
    type: IItemType.submenu,
    label: '数据',
    icon: 'airplay',
    children: [
      {
        path: "/report",
        name: "report",
        type: IItemType.menuitem,
        label: '基础报表',
        icon: 'Aim',
        component: () => import("@/pages/datacenter/index.vue"),
      },
      {
        path: "/logs",
        name: "logs",
        type: IItemType.menuitem,
        label: '系统报表',
        icon: 'Aim',
        component: () => import("@/pages/logs/index.vue"),
      },
      {
        path: "/self-report",
        name: "self-report",
        type: IItemType.menuitem,
        label: '定制报表',
        icon: 'Aim',
        component: () => import("@/pages/datacenter/self-made.vue"),
      },
      {
        path: "/datacenter/post-detail",
        name: "datacenter-post-detail",
        hidden: true,
        type: IItemType.none,
        component: () => import("@/pages/datacenter/feels-detail.vue"),
      },
    ]
  },
  {
    name: "talk",
    type: IItemType.submenu,
    label: '询盘',
    icon: 'message-circle',
    children: [
      {
        path: "/chat",
        name: "chat",
        type: IItemType.menuitem,
        label: 'SCRUM',
        icon: 'Aim',
        component: () => import("@/pages/chat/index.vue"),
      },
    ]
  },
  {
    name: "flow",
    type: IItemType.submenu,
    label: '流水线',
    icon: 'Menu',
    children: [
      {
        path: "/flow",
        name: "flow",
        type: IItemType.menuitem,
        label: '基础流水线',
        icon: 'Aim',
        component: () => import("@/pages/flow/index.vue"),
      },
    ]
  }
]
export default fullRoutes
